import { render } from "./ResetLoader.vue?vue&type=template&id=5e859104"
import script from "./ResetLoader.vue?vue&type=script&lang=js"
export * from "./ResetLoader.vue?vue&type=script&lang=js"

import "./ResetLoader.vue?vue&type=style&index=0&id=5e859104&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__